export default {
    baseAPI: process.env.REACT_APP_BASE_API,
    disableSSL: process.env.REACT_APP_DISABLE_SSL,
    iamUrl: process.env.REACT_APP_IAM_URL,
    accountsUrl: process.env.REACT_APP_ACCOUNTS_URL,
    iamAudience: process.env.REACT_APP_IAM_AUDIENCE,
    iamDomain: process.env.REACT_APP_IAM_DOMAIN,
    iamClientId: process.env.REACT_APP_IAM_CLIENT_ID,
    iamAdminConsoleOrgId: process.env.REACT_APP_ADMIN_CONSOLE_ORG_ID,
    licenseLicenseUrl: process.env.REACT_APP_LICENSE_LICENSE_URL,
    licenseProductUrl: process.env.REACT_APP_LICENSE_PRODUCT_URL,
    implementationGuideUrl: process.env.REACT_APP_IMPLEMENTATION_GUIDE_URL,
    maintenanceMode: process.env.REACT_APP_SHOW_MAINTENANCE_PAGE,
    commonAccountsUrl: process.env.REACT_APP_COMMON_ACCOUNTS_URL,
    logRocketEnv: process.env.REACT_APP_LOGROCKET_ENV,
    skewedAnalyticsUploadedReportsUrl: process.env.REACT_APP_SKEWED_ANALYTICS_UPLOADED_REPORTS_URL,
};
